module.exports = __webpack_public_path__ + "static/media/dianbanrezhikong.a0889b7b.png";